// extracted by mini-css-extract-plugin
module.exports = {"growth-container":"growth-container_growth-container__iI8mR","content-container":"growth-container_content-container__gdu4N"};